<svg class="svg-line" [innerHTML]="polyLine | html"></svg>
